import { Button } from '@/components/form/Button';
import SiEdit from '@/icons/SiEdit';

import { ButtonVariant } from '@/components/form/buttonHelper';
import DaasTableRowCell from '@/components/table/DaasTableRowCell';
import { useUser } from '@/services/api/hooks/users';
import { usePrintCurrencyString } from '@/utils/price';
import { format } from 'date-fns';
import { FunctionComponent } from 'react';
import { CreditCheckTableData } from './CreditCheckTable';
import { CreditCheckStatus, getCreditCheckStatus } from './creditCheckHelper';
import { EditCreditCheck } from './creditCheckTable.types';

interface CreditCheckTableRowProps {
  data: CreditCheckTableData;
  onEdit: EditCreditCheck;
}

const CreditCheckTableRow: FunctionComponent<CreditCheckTableRowProps> = ({ data, onEdit }) => {
  const [user] = useUser(data.userId);

  const isCustomerCreditCheck = !!data.mspId;

  const printCurrencyString = usePrintCurrencyString({ regionCode: data.regionCode, forceSpecifyRegion: true });
  const printedLimit = printCurrencyString(data.creditLimit ? data.creditLimit * 100 : undefined);

  return (
    <>
      <DaasTableRowCell>{data.name}</DaasTableRowCell>
      <DaasTableRowCell>{data.number}</DaasTableRowCell>
      <DaasTableRowCell>{printedLimit || '-'}</DaasTableRowCell>
      <DaasTableRowCell>{data.createdAt ? format(data.createdAt, 'dd/MM/yyyy HH:mm') : '-'}</DaasTableRowCell>
      <DaasTableRowCell>{data.lastModified ? format(data.lastModified, 'dd/MM/yyyy HH:mm') : '-'}</DaasTableRowCell>
      <DaasTableRowCell>{user ? `${user.givenName} ${user.surname}` : '-'}</DaasTableRowCell>
      {isCustomerCreditCheck && (
        <DaasTableRowCell>
          {data.status !== undefined ? getCreditCheckStatus(data.status as unknown as CreditCheckStatus) : '-'}
        </DaasTableRowCell>
      )}
      <DaasTableRowCell>
        <Button
          onClick={() =>
            onEdit(
              data.regionCode || 'GB',
              isCustomerCreditCheck ? data.mspId! : data.id,
              data.creditLimitId,
              isCustomerCreditCheck ? data.id : undefined
            )
          }
          className="p-0"
          variant={ButtonVariant.Ghost}
        >
          <SiEdit className="text-xl" />
        </Button>
      </DaasTableRowCell>
    </>
  );
};

export default CreditCheckTableRow;
